<template>
  <div class="bulk-actions-bar">
    <div class="selected-info">
      <span class="selected-count">{{ selectedCount }}</span> courses selected
    </div>
    <div class="bulk-actions">
      <button @click="$emit('status')" class="bulk-action-button status">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="action-icon">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <path d="M14 2v6h6"/>
          <path d="M9 13h6"/>
          <path d="M9 17h6"/>
          <path d="M9 9h1"/>
        </svg>
        Change Status
      </button>
      <button @click="$emit('category')" class="bulk-action-button category">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="action-icon">
          <path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2z"/>
        </svg>
        Change Category
      </button>
      <button @click="$emit('delete')" class="bulk-action-button delete">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="action-icon">
          <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/>
          <line x1="10" y1="11" x2="10" y2="17"/>
          <line x1="14" y1="11" x2="14" y2="17"/>
        </svg>
        Delete Selected
      </button>
      <button @click="$emit('deselect-all')" class="bulk-action-button cancel">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="action-icon">
          <circle cx="12" cy="12" r="10"/>
          <line x1="15" y1="9" x2="9" y2="15"/>
          <line x1="9" y1="9" x2="15" y2="15"/>
        </svg>
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BulkActionsBar',
  props: {
    selectedCount: {
      type: Number,
      required: true
    }
  },
  emits: ['delete', 'category', 'status', 'deselect-all']
}
</script>

<style scoped>
.bulk-actions-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #EEF2FF;
  border: 1px solid #C7D2FE;
  border-radius: 16px;
  padding: 0.75rem 1.5rem;
  margin-bottom: 1.5rem;
  animation: slide-in 0.3s ease;
}

@keyframes slide-in {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.selected-info {
  font-size: 0.875rem;
  color: #4F46E5;
  font-weight: 500;
}

.selected-count {
  font-weight: 700;
  font-size: 1rem;
}

.bulk-actions {
  display: flex;
  gap: 0.75rem;
}

.bulk-action-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  padding: 0.5rem 0.875rem;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.bulk-action-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.bulk-action-button .action-icon {
  width: 16px;
  height: 16px;
}

.bulk-action-button.status {
  color: #0D9488;
  border-color: #CCFBF1;
}

.bulk-action-button.status:hover {
  background-color: #F0FDFA;
}

.bulk-action-button.category {
  color: #0891B2;
  border-color: #CFFAFE;
}

.bulk-action-button.category:hover {
  background-color: #ECFEFF;
}

.bulk-action-button.delete {
  color: #DC2626;
  border-color: #FEE2E2;
}

.bulk-action-button.delete:hover {
  background-color: #FEF2F2;
}

.bulk-action-button.cancel {
  color: #64748B;
  border-color: #F1F5F9;
}

.bulk-action-button.cancel:hover {
  background-color: #F1F5F9;
}

@media (max-width: 768px) {
  .bulk-actions-bar {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }
  
  .bulk-actions {
    width: 100%;
    flex-wrap: wrap;
  }
  
  .bulk-action-button {
    flex: 1;
    min-width: calc(50% - 0.375rem);
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .bulk-action-button {
    min-width: 100%;
  }
}
</style> 